var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1642 14.0766L21.3865 5.27742C21.124 5.09653 20.8155 5 20.5 5C20.1845 5 19.876 5.09653 19.6135 5.27742L6.83577 14.0766C6.61678 14.2276 6.4373 14.432 6.3133 14.6719C6.1893 14.9118 6.12461 15.1796 6.125 15.4515V29.7502C6.125 30.4795 6.40547 31.1789 6.90469 31.6946C7.40392 32.2103 8.08102 32.5 8.78704 32.5H32.213C32.919 32.5 33.5961 32.2103 34.0953 31.6946C34.5945 31.1789 34.875 30.4795 34.875 29.7502V15.4515C34.8754 15.1796 34.8107 14.9118 34.6867 14.6719C34.5627 14.432 34.3832 14.2276 34.1642 14.0766ZM15.4168 23.1508L9.31945 27.5931V18.6564L15.4168 23.1508ZM18.6845 24.8007H22.3155L28.353 29.2003H12.6536L18.6845 24.8007ZM25.5832 23.1508L31.6806 18.6536V27.5903L25.5832 23.1508ZM20.5 8.63487L30.464 15.4969L22.3115 21.501H18.6885L10.536 15.4969L20.5 8.63487Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b7c81d62b57d01528cce5a36332e61a1.svg";
export { ForwardRef as ReactComponent };